import i18next, { Resource } from 'i18next'

export function addTranslation(ns: string, resources: Resource){
    for(const [lng, resource] of Object.entries(resources)){
        i18next.addResourceBundle(lng, ns, resource, true, true)
    }
}